import React, {Component} from 'react';
import Navigation from './Navigation';
import ButtonLink from '../components/output/ButtonLink';
import {Horizontal} from '../components/container/LayoutRow';
import Modal, {ConfirmDisableModal, ConfirmModal} from '../components/container/Modal';
import InputText from '../components/input/InputText';
import ToggleInputText from '../components/input/ToggleInputText';
import InputDate from '../components/input/InputDate';
import {ackSDSAdd, count, list, remove, removeDisable, resend} from './restApi';
import {buildFilterObject} from '../functions/filters';
import {Loader as LoaderIcon, X as XIcon} from 'react-feather';
import {classNames} from '../functions/classNames';
import PropTypes from 'prop-types';
import getLabel from '../translations/messages';
import debounce from 'lodash.debounce';
import './Crud.css';
import RemoteInputSelect from "../components/input/RemoteInputSelect";

export const defaultFilters = () => {
  return [{ name: 'fullSearch', placeholder: 'general.fullSearch' }];
};

class List extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      data: [],
      filters: this.initFilters(this.props.hasAdditionalFilters),
      disabledDefaultFilter: (this.props.hasAdditionalFilters === true),
    };

    this.fetchResults();

    setTimeout(() => {
        if( this.state.isLoading === undefined ) {
          this.setState({ isLoading: true })
        }
    }, 600)

  }

  componentWillUnmount = () => {
    const { entityRoute } = this.props;
    const { filters } = this.state;

    localStorage.setItem(entityRoute, JSON.stringify(filters));
  };

  fetchResults = () => {
    count(this.props.entityName, this.state.filters)
      .then(data => this.setState({ count: data.value }, this.fetchActualResults));
  };

  fetchActualResults = () => {
    list(this.props.entityName, this.state.filters)
      .then(data => this.setState({
                        data: data,
                        isLoading: false,
                        isPageLoading: false,
                      }));
  };

  handleAdd = (id) => {
    const modalContent = getLabel(this.context.locale, 'general.acknowlegmentSDShandleAdd.text');

    this.setState({
      showModal: true,
      modalContent: modalContent,
      modalSubmit: () => this.handleActualAckSDSAdd(id),
    });
  };

  handleActualAckSDSAdd = (id) => {
    ackSDSAdd(this.props.entityName, id)
        .then(res => {
            this.setState({
            showModal: false,
            modalContent: '',
            modalSubmit: null,
          }, this.fetchResults);
        }
      
        )
        .catch(err => {
        		this.setState({
        	          showModal: false,
        	          modalContent: '',
        	          modalSubmit: null,
        	          title: 'general.errorOccurred',
        	          showWarningModal: true,
        	          error: err.message,
        	    })
        }
      );
  };
    
  
  handleResend = (id) => {
    const modalContent = getLabel(this.context.locale, 'general.confirmResend.text');

    this.setState({
      showModal: true,
      modalContent: modalContent,
      modalSubmit: () => this.handleActualResend(id),
    });
  };

  handleActualResend = (id) => {
    resend(this.props.entityName, id)
        .then(res => {
          debugger;
            this.setState({
            showModal: false,
            modalContent: res,
            modalSubmit: null,
          }, this.fetchResults);
        }
      
        )
        .catch(err => {
        		this.setState({
        	          showModal: false,
        	          modalContent: '',
        	          modalSubmit: null,
        	          title: 'general.errorOccurred',
        	          showWarningModal: true,
        	          error: err.message,
        	    })
        }
      );
  };
    

  handleRemove = (id) => {
    const modalContent = getLabel(this.context.locale, 'general.confirmDeletion.text');

    this.setState({
      showModal: true,
      modalContent: modalContent,
      modalSubmit: () => this.handleActualRemove(id),
    });
  };

  handleActualRemove = (id) => {
    remove(this.props.entityName, id)
        .then(res => this.setState({
            showModal: false,
            modalContent: '',
            modalSubmit: null,
          }, this.fetchResults)

        )
        .catch(err => {
        	if(this.props.entityName === "departments"){
                this.setState({
                    showModal: false,
                    modalContent: '',
                    modalSubmit: null,
                    title: 'general.errorOccurred',
                    showDisableModal: true,
                    modalDisableContent: err.message,
                    modalDisableSubmit: () => this.handleActualDisable(id),
                  })
        	}else{
        		this.setState({
        	          showModal: false,
        	          modalContent: '',
        	          modalSubmit: null,
        	          title: 'general.errorOccurred',
        	          showWarningModal: true,
        	          error: err.message,
        	    })
        	}
        }    
      );
  };
  
  handleActualDisable = (id) => {
	  removeDisable(this.props.entityName, id)
	  .then(res => this.setState({
		  showDisableModal: false,
		  modalDisableContent: '',
		  modalDisableSubmit: null,
          }, this.fetchResults)

        ).catch(err => {
        	this.setState({
      		  showDisableModal: false,
    		  modalDisableContent: '',
    		  modalDisableSubmit: null,
  	          title: 'general.errorOccurred',
  	          showWarningModal: true,
  	          error: err.message,        
        });
        });
  };
  

  toggleModal = (content, action, isConfirm = true) => {
    if( isConfirm ) {
      this.toggleConfirmModal(content, action);

    } else {
      this.toggleWarningModal(content);

    }

  };

  toggleConfirmModal = (content, action) => {
    if (this.state.showModal) {
      this.setState({
        showModal: false,
        modalContent: '',
        modalSubmit: null,
      });

    } else {
      this.setState({
        showModal: true,
        modalContent: content,
        modalSubmit: action,
      });

    }
  }

  toggleWarningModal = content => {
    if (this.state.showWarningModal) {
      this.setState({
        showWarningModal: false,
        error: '',
        warningModalTitle: '',
      });

    } else {
      this.setState({
        showWarningModal: true,
        error: content,
        warningModalTitle: '',
      });

    }
  }

  toggleDisableModal = (content, action) => {
    if (this.state.showDisableModal) {
      this.setState({
        showDisableModal: false,
        modalDisableContent: '',
        modalDisableSubmit: null,
      });

    } else {
      this.setState({
    	  showDisableModal: true,
    	  modalDisableContent: content,
    	  modalDisableSubmit: action,
      });

    }
  }
  
  closeModal = () => {
    this.setState({ showModal: false, error: '' });
  };

  closeWarningModal = () => {
    this.setState({ showWarningModal: false, error: '' });
  };
  
  closeDisableModal = () => {
    this.setState({ showDisableModal: false, error: '' });
  };

  initFilters = (reset, fromClear) => {
    const { filters, defaultOrdering, defaultAsc, entityRoute, hasAdditionalFilters } = this.props;
    const asc = (defaultAsc === undefined ? true : defaultAsc);

    const saved = localStorage.getItem(entityRoute);
    let result;

    if (saved && !reset) {
      result = JSON.parse(saved);

    } else {
      result = (fromClear && hasAdditionalFilters ? buildFilterObject(defaultFilters()) : buildFilterObject(filters));
      result.order = defaultOrdering;
      result.asc = asc ? 'true' : 'false';
      result.startPosition = 0;
      result.maxResults = 10;
    }

    localStorage.setItem(entityRoute, JSON.stringify(result));
    return result;
  };

  clearFilters = () => {
    this.setState({
      filters: this.initFilters(true, true),
      disabledDefaultFilter: false,
    }, this.fetchResults);
  };

  applyFilter = (e) => {
    const { filtersValidation } = this.props;
    const updatedFilters = { ...this.state.filters };

    updatedFilters[e.target.name] = e.target.value;
    updatedFilters.startPosition = 0;

    if (filtersValidation) {
      filtersValidation(updatedFilters, e.target.name);
    }

    this.setState({ filters: updatedFilters }, this.searchFilter);
  };

  applyNavigation = (e) => {
    const updatedFilters = { ...this.state.filters };
    updatedFilters[e.target.name] = e.target.value;

    this.setState({ filters: updatedFilters, isPageLoading: true }, this.fetchResults);
  };

  searchFilter = debounce(() => this.fetchResults(), 300);

  renderAdditionalButtons = () => {
    const { additionalButtons } = this.props;

    if (!additionalButtons) {
      return;
    }

    return additionalButtons(this.state.filters, this.context, this.toggleModal);
  };

  renderFilters = () => {
    return <div className={this.props.panic ? "panic-filters" : "filters"}>
            {this.props.filters
              .filter(f => f.placeholder)
              .map((f, i) => this.renderFilter(f, i))}
            <span className="clear-filters-button">
              <span className="tooltip">{getLabel(this.context.locale, 'general.clearFilters')}</span>
              <a onClick={this.clearFilters}><XIcon size={this.props.panic ? 24 : 16} /></a>
            </span>
          </div>;
  };

  renderFilter = (f, i) => {
    if (f.type === 'date') {
      return (<InputDate
          key={i}
          name={f.name}
          value={this.state.filters[f.name]}
          handleChange={this.applyFilter}
          placeholder={getLabel(this.context.locale, f.placeholder)}
        />);
    }

    if (f.type === 'exclusion') {
      return (<ToggleInputText
          key={i}
          name={f.name}
          value={this.state.filters[f.name]}
          handleChange={this.applyFilter}
          placeholder={getLabel(this.context.locale, f.placeholder)}
          toggleName={f.toggleName}
          toggleLabel={f.toggleLabel}
          toggleValue={this.state.filters[f.toggleName]}
        />);
    }

    if (f.type === 'remote') {
      return (<RemoteInputSelect
                key={i}
                from={f.from}
                optionValueName={f.optionValueName}
                optionLabelName={f.optionLabelName}
                value={this.state.filters[f.name]}
                handleChange={this.applyFilter}
                name={f.name}
                localize={f.localize}
                placeholder={f.placeholder}
                multi={true}
            />);
    }

    return (<InputText
        key={i}
        name={f.name}
        value={this.state.filters[f.name]}
        handleChange={this.applyFilter}
      placeholder={getLabel(this.context.locale, f.placeholder)}
        disabled={this.state.disabledDefaultFilter ? 'disabled' : ''}
      />);
  };

  withData = (component) => (
    React.cloneElement(component, {
      ...component.props,
      entityName: this.props.entityName,
      entityRoute: this.props.entityRoute,
      data: this.state.data,
      handleFilterChange: this.applyFilter,
      filters: this.state.filters,
      handleRemove: this.handleRemove,
      handleResend: this.handleResend,
      handleAdd: this.handleAdd,
      updateResults: this.fetchResults,
      toggleModal: this.toggleModal,
    })
  );

  render() {
    const { hideAddButton, showSearchButton, entityRoute, component } = this.props;
    const { count, filters, isLoading, isPageLoading } = this.state;

    return (
      <div className={classNames('List', this.props.crudClassName)}>
        <ConfirmDisableModal
            isOpen={this.state.showDisableModal}
            title="general.confirmDeletion.title"
            handleCloseModal={this.closeDisableModal}
            submitAction={this.state.modalDisableSubmit}
        >
          <div style={{ padding: 20 }}>{this.state.modalDisableContent}</div>
        </ConfirmDisableModal>
       <ConfirmModal
        isOpen={this.state.showModal}
        title="general.confirmDeletion.title"
        handleCloseModal={this.closeModal}
        submitAction={this.state.modalSubmit}
    >
      <div style={{ padding: 20 }}>{this.state.modalContent}</div>
    </ConfirmModal>
        <Modal
            isOpen={this.state.showWarningModal}
            title={this.state.warningModalTitle}
            handleCloseModal={this.closeWarningModal}>
          <div style={{ padding: 20 }}>{this.state.error}</div>
        </Modal>
        <Horizontal style={{ alignItems: 'center' }}>
          <h2>
            <div className="title">{getLabel(this.context.locale, this.props.title)}</div>
            <div className="count">{count ? count + ' ' + getLabel(this.context.locale, 'general.results') : ''}</div>
          </h2>
          <div className="list-control">
            {this.renderAdditionalButtons()}
            {this.renderFilters()}
            {hideAddButton ? '' :
              <ButtonLink
                to={'/' + entityRoute + '/add'}
                label="general.add"
                style={{ margin: '0 10px' }} />}
            {showSearchButton ?
              <ButtonLink
                to={{
                  pathname: '/' + this.props.entityRoute + '/search',
                  state: { filters: filters },
                }}
                label="general.advancedSearch"
                style={{ margin: '0 10px 0 5px' }} /> : ''}
          </div>
        </Horizontal>
        {isLoading === undefined? '' :
          isLoading === true ? <div className="loading"><LoaderIcon size={30} /></div> :
            <div className="list-container">
              {this.withData(component)}
              {count ?
              <Navigation
                  count={count}
                  isLoading={isPageLoading}
                  startPosition={filters.startPosition}
                  maxResults={filters.maxResults}
                  handleNavigation={this.applyNavigation}
              /> : ''}
          </div>
        }
      </div>
    );
  }
}

List.contextTypes = {
  locale: PropTypes.string,
  config: PropTypes.object
};

export default List;



// WEBPACK FOOTER //
// ./src/main/cruds/List.js